module.exports = __webpack_public_path__ + "static/logo-white-c1153be79bccd5b8906bf3cca4b5ff1f.png";